/* eslint-disable react-hooks/exhaustive-deps */
import {
  Box,
  Button,
  Flex,
  Radio,
  RadioGroup,
  Scrollbar,
  Space,
  Stack,
  Text,
  useColorMode,
  useColorStyle,
} from '@tonic-one/react';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { GlobalApi } from '@Apis';
import EditableList from '../../../../components/EditableList';
import { useSiderWidthStore } from '../../../../models/useSiderWidthModel';
import {
  DeleteHighProfileDomainsProps,
  HighProfileDomainsProps,
} from '../../../../types/globalSetting';
import common from '../../../../utils/common';
import { ValidProps } from '../../../../types';
import { validateDomain } from '../../../../utils/validate';
import { usePermissionStore } from '../../../../models/usePermissionModel';
import { PermissionNameEnum } from '@Types/permissions';
import config from '../../../../config';
import CSpinner from '../../../../components/CSpinner';
import ImportModal from '@Policy/AdvancedThreatProtection/PolicyTemplate/Components/ImportModal';

const HighProfileDomains = () => {
  const [colorMode] = useColorMode();
  const [colorStyle] = useColorStyle({ colorMode });
  const [loading, setLoading] = useState<boolean>(false);
  const { t } = useTranslation();
  const { siderWidth } = useSiderWidthStore();
  const { widthEditablePermission } = usePermissionStore();
  const [highProfileDomains, setHighProfileDomains] = useState<string[]>([]);
  const [highProfileExceptionDomains, setHighProfileExceptionDomains] =
    useState<string[]>([]);
  const [highProfileThreshold, setHighProfileThreshold] = useState<number>(0);
  const [data, setData] = useState<HighProfileDomainsProps>();
  const [
    isHighProfileDomainsImportModalVisible,
    setHighProfileDomainsImportModalVisible,
  ] = useState(false);
  const [
    isHighProfileExceptionDomainsImportModalVisible,
    setHighProfileExceptionDomainsImportModalVisible,
  ] = useState(false);
  // const onExport = () => {
  //   let content = '';
  //   // items[selectedItem].forEach(function (val) {
  //   //   content += val + '\r\n';
  //   // });
  //   common.exportFile('export.txt', content, 'text/plain');
  // };
  const validatesHighProfileDomains: ValidProps[] = [
    {
      validMethod: validateDomain,
      errMsg: t('common.error.invalidDomain'),
    },
    {
      validMethod: (value: string) => {
        return !highProfileDomains.includes(value);
      },
      errMsg: t('common.error.duplicateDomain'),
    },
  ];
  const validatesHighProfileExceptionDomains: ValidProps[] = [
    {
      validMethod: validateDomain,
      errMsg: t('common.error.invalidDomain'),
    },
    {
      validMethod: (value: string) => {
        return !highProfileExceptionDomains.includes(value);
      },
      errMsg: t('common.error.duplicateDomain'),
    },
  ];
  const onDeleteHighProfileDomains = (item: string) => {
    const temp = highProfileDomains.filter((i) => i !== item);
    setHighProfileDomains(temp);
  };

  const onDeleteHighProfileExceptionDomains = (item: string) => {
    const temp = highProfileExceptionDomains.filter((i) => i !== item);
    setHighProfileExceptionDomains(temp);
  };

  const onAddHighProfileExceptionDomains = (item: string) => {
    const temp = [...highProfileExceptionDomains, item];
    setHighProfileExceptionDomains(temp);
  };

  const onAddHighProfileDomains = (item: string) => {
    const temp = [...highProfileDomains, item];
    setHighProfileDomains(temp);
  };

  const handleImportHighProfileDomains = (content: string[]) => {
    console.log(
      content,
      highProfileDomains,
      Array.from(new Set(highProfileDomains.concat(content)))
    );
    setHighProfileDomains(
      Array.from(new Set(highProfileDomains.concat(content)))
    );
    setHighProfileDomainsImportModalVisible(false);
  };

  const handleImportHighProfileExceptionDomains = (content: string[]) => {
    setHighProfileExceptionDomains(
      Array.from(new Set(highProfileExceptionDomains.concat(content)))
    );
    setHighProfileExceptionDomainsImportModalVisible(false);
  };

  const onImportHighProfileDomains = () => {
    setHighProfileDomainsImportModalVisible(true);
  };

  const onImportHighProfileExceptionDomains = () => {
    setHighProfileExceptionDomainsImportModalVisible(true);
  };

  const onExportHighProfileDomains = () => {
    let content = '';
    highProfileDomains.forEach(function (val) {
      content += val + '\r\n';
    });
    common.exportFile(
      `${t('globalSetting.highProfileDomains.tab.title')}.txt`,
      content,
      'text/plain'
    );
  };

  const onExportHighProfileExceptionDomains = () => {
    let content = '';
    highProfileExceptionDomains.forEach(function (val) {
      content += val + '\r\n';
    });
    common.exportFile(
      `${t('globalSetting.highProfileDomains.exception.title')}.txt`,
      content,
      'text/plain'
    );
  };

  const onChange = (value: string) => {
    setHighProfileThreshold(Number(value));
  };

  const onSave = async () => {
    const updateHighProfileDomainsProps: HighProfileDomainsProps = {
      highProfileDomains: [],
      highProfileExceptionDomains: [],
      highProfileThreshold: 0,
    };
    const deleteHighProfileDomainsProps: DeleteHighProfileDomainsProps = {
      highProfileDomains: [],
      highProfileExceptionDomains: [],
    };
    //compare to be deleted
    deleteHighProfileDomainsProps.highProfileDomains =
      data?.highProfileDomains.filter(
        (item) => !highProfileDomains.includes(item)
      ) || [];
    deleteHighProfileDomainsProps.highProfileExceptionDomains =
      data?.highProfileExceptionDomains.filter(
        (item) => !highProfileExceptionDomains.includes(item)
      ) || [];

    //compare to be added
    updateHighProfileDomainsProps.highProfileDomains =
      highProfileDomains.filter(
        (item) => !data?.highProfileDomains.includes(item)
      ) || [];
    updateHighProfileDomainsProps.highProfileExceptionDomains =
      highProfileExceptionDomains.filter(
        (item) => !data?.highProfileExceptionDomains.includes(item)
      ) || [];
    updateHighProfileDomainsProps.highProfileThreshold = highProfileThreshold;
    try {
      if (
        deleteHighProfileDomainsProps.highProfileDomains.length > 0 ||
        deleteHighProfileDomainsProps.highProfileExceptionDomains.length > 0
      ) {
        await GlobalApi.deleteHighProfileDomain(deleteHighProfileDomainsProps);
      }
      if (
        updateHighProfileDomainsProps.highProfileDomains.length > 0 ||
        updateHighProfileDomainsProps.highProfileExceptionDomains.length > 0 ||
        updateHighProfileDomainsProps.highProfileThreshold !==
          data?.highProfileThreshold
      ) {
        await GlobalApi.updateHighProfileDomain(updateHighProfileDomainsProps);
      }
      window.showNotification({
        titleMsg: t('globalSetting.highProfileDomains.add.success'),
        severity: 'success',
      });
      await reloadData();
    } catch (error) {
      window.showNotification({
        titleMsg: t('common.apiException.internalError'),
        severity: 'error',
      });
    }
  };

  async function reloadData() {
    try {
      setLoading(true);
      const highProfileDomainsProps: HighProfileDomainsProps = (
        await GlobalApi.getHighProfileDomain()
      ).data;
      setHighProfileDomains(highProfileDomainsProps.highProfileDomains);
      setHighProfileExceptionDomains(
        highProfileDomainsProps.highProfileExceptionDomains
      );
      setHighProfileThreshold(highProfileDomainsProps.highProfileThreshold);
      setData(highProfileDomainsProps);
    } catch (e) {
      window.showNotification({
        titleMsg: t('common.apiException.internalError'),
        severity: 'error',
      });
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    (async function doCall() {
      await reloadData();
    })();
  }, []);
  return (
    <Box>
      {loading && <CSpinner />}
      <ImportModal
        isVisible={isHighProfileDomainsImportModalVisible}
        onClose={() => {
          setHighProfileDomainsImportModalVisible(false);
        }}
        onImport={handleImportHighProfileDomains}
      />
      <ImportModal
        isVisible={isHighProfileExceptionDomainsImportModalVisible}
        onClose={() => {
          setHighProfileExceptionDomainsImportModalVisible(false);
        }}
        onImport={handleImportHighProfileExceptionDomains}
      />
      <Scrollbar maxHeight={'calc(100vh - 48px- 64px)'} overflow="scroll">
        <Flex m="16px 0px">
          <Text
            color={colorStyle.color.secondary}
            lineHeight="lg"
            maxWidth={1000}
          >
            {t('globalSetting.highProfileDomains.description', {
              count:
                config.ui.globalSettings.limitation.highProfileDomainsMaxCount,
            })}
          </Text>
        </Flex>
        <Flex m="16px 0px">
          <Text>
            <Space>{t('globalSetting.note.title')}</Space>
            <Space width="1x"></Space>
            <Space color={colorStyle.color.secondary}>
              {t('globalSetting.note.applyToAllOrganizations')}
            </Space>
          </Text>
        </Flex>

        <Flex m="16px 0px">
          <Text fontSize="lg" lineHeight="lg" color={colorStyle.color.primary}>
            {t('globalSetting.highProfileDomains.tab.title')}
          </Text>
        </Flex>
        <Flex m="16px 0px">
          <EditableList
            onDelete={onDeleteHighProfileDomains}
            onAdd={onAddHighProfileDomains}
            onExport={onExportHighProfileDomains}
            onImport={onImportHighProfileDomains}
            list={highProfileDomains.map((item) => ({
              name: item,
              value: item,
            }))}
            disabled={
              !widthEditablePermission(PermissionNameEnum.administrator) ||
              highProfileExceptionDomains.length >=
                config.ui.globalSettings.limitation.highProfileDomainsMaxCount
            }
            limit={
              config.ui.globalSettings.limitation.highProfileDomainsMaxCount
            }
            description={''}
            width={'800px'}
            size={4}
            placeholder={t('globalSetting.internalDomains.placeholder.content')}
            validates={validatesHighProfileDomains}
          />
        </Flex>

        <Flex m="16px 0px">
          <Text fontSize="lg" lineHeight="lg" color={colorStyle.color.primary}>
            {t('globalSetting.highProfileDomains.exception.title')}
          </Text>
        </Flex>
        <Flex m="16px 0px">
          <EditableList
            onDelete={onDeleteHighProfileExceptionDomains}
            onAdd={onAddHighProfileExceptionDomains}
            onExport={onExportHighProfileExceptionDomains}
            onImport={onImportHighProfileExceptionDomains}
            list={highProfileExceptionDomains.map((item) => ({
              name: item,
              value: item,
            }))}
            disabled={
              !widthEditablePermission(PermissionNameEnum.administrator) ||
              highProfileExceptionDomains.length >=
                config.ui.globalSettings.limitation.highProfileDomainsMaxCount
            }
            limit={
              config.ui.globalSettings.limitation.highProfileDomainsMaxCount
            }
            description={''}
            width={'800px'}
            size={4}
            placeholder={t('globalSetting.internalDomains.placeholder.content')}
            validates={validatesHighProfileExceptionDomains}
          />
        </Flex>

        <Flex m="16px 0px">
          <Text fontSize="lg" lineHeight="lg" color={colorStyle.color.primary}>
            {t('globalSetting.highProfileDomains.detectionThreshold.title')}
          </Text>
        </Flex>

        <Flex m="16px 0px 84px 0px">
          <RadioGroup
            defaultValue="1"
            value={highProfileThreshold.toString()}
            onChange={onChange}
          >
            <Stack direction="row" spacing="3x">
              <Radio name="aggressive" value="2">
                {t(
                  'globalSetting.highProfileDomains.detectionThreshold.aggressive'
                )}
              </Radio>
              <Radio name="normal" value="1">
                {t(
                  'globalSetting.highProfileDomains.detectionThreshold.normal'
                )}
              </Radio>
              <Radio name="conservative" value="0">
                {t(
                  'globalSetting.highProfileDomains.detectionThreshold.conservative'
                )}
              </Radio>
            </Stack>
          </RadioGroup>
        </Flex>
        <Flex
          position="fixed"
          pl="5x"
          bottom={0}
          left={270 + siderWidth}
          right={0}
          background={colorStyle.background.secondary}
          height={64}
          align="center"
          justify="flex-start"
        >
          <Button
            variant="primary"
            onClick={onSave}
            disabled={
              !widthEditablePermission(PermissionNameEnum.administrator)
            }
          >
            {t('common.button.save')}
          </Button>
        </Flex>
      </Scrollbar>
    </Box>
  );
};
export default HighProfileDomains;
